// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaderboard {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  padding: 0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.table-container {
  overflow-x: auto;
  border-radius: 8px;
}

.leaderboard-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.leaderboard-table thead {
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.leaderboard-table th {
  padding: 16px 16px;
  text-align: left;
  font-weight: 500;
  font-size: 0.9rem;
  color: #495057;
}

.leaderboard-table th.balance-header {
  text-align: right;
}

.leaderboard-table th.change-header {
  text-align: center;
}

.leaderboard-table td {
  padding: 12px 16px;
  border-bottom: 1px solid #f8f9fa;
  vertical-align: middle;
  font-size: 0.9rem;
}

.leaderboard-row {
  transition: background-color 0.2s ease;
}

.leaderboard-row:hover {
  background-color: #f8f9fa;
}

.leaderboard-row:last-child td {
  border-bottom: none;
}

/* Призовые места */
.prize-1 {
  background-color: rgba(255, 215, 0, 0.1);
}

.prize-2 {
  background-color: rgba(192, 192, 192, 0.1);
}

.prize-3 {
  background-color: rgba(205, 127, 50, 0.1);
}

.prize-4, .prize-5 {
  background-color: rgba(74, 144, 226, 0.1);
}

.position-cell {
  font-weight: 600;
  color: #495057;
  text-align: center;
  width: 80px;
}

.address-cell {
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  color: #495057;
  font-size: 0.85rem;
}

.address-link {
  color: #007bff;
  text-decoration: none;
  transition: color 0.2s ease;
  border-radius: 4px;
  padding: 2px 4px;
  display: inline-block;
}

.address-link:hover {
  color: #0056b3;
  background-color: rgba(0, 123, 255, 0.1);
  text-decoration: underline;
}

.balance-cell {
  font-weight: 600;
  color: #5d8a66;
  text-align: right;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
}

.change-cell {
  font-weight: 600;
  text-align: center;
  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  font-size: 0.9rem;
  width: 120px;
}

.change-positive {
  color: #28a745;
  font-weight: 500;
}

.change-negative {
  color: #dc3545;
  font-weight: 500;
}

.change-neutral {
  color: #6c757d;
  font-weight: 500;
}

.no-data {
  text-align: center;
  padding: 40px 20px;
  color: #6c757d;
}

.no-data-icon {
  font-size: 3rem;
  margin-bottom: 15px;
}

.no-data h3 {
  margin-bottom: 8px;
  color: #495057;
  font-weight: 500;
}

/* Responsive design */
@media (max-width: 768px) {
  .leaderboard-table th,
  .leaderboard-table td {
    padding: 10px 10px;
    font-size: 0.85rem;
  }
  
  .position-cell {
    width: 60px;
  }
}

@media (max-width: 480px) {
  .leaderboard-table th,
  .leaderboard-table td {
    padding: 8px 10px;
    font-size: 0.8rem;
  }
  
  .position-cell {
    width: 50px;
  }
  
  .address-cell {
    font-size: 0.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Leaderboard.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,UAAU;EACV,wCAAwC;EACxC,2BAA2B;EAC3B,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,yEAAyE;EACzE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,yEAAyE;AAC3E;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yEAAyE;EACzE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".leaderboard {\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 8px;\n  padding: 0;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.table-container {\n  overflow-x: auto;\n  border-radius: 8px;\n}\n\n.leaderboard-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.leaderboard-table thead {\n  background: #f8f9fa;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.leaderboard-table th {\n  padding: 16px 16px;\n  text-align: left;\n  font-weight: 500;\n  font-size: 0.9rem;\n  color: #495057;\n}\n\n.leaderboard-table th.balance-header {\n  text-align: right;\n}\n\n.leaderboard-table th.change-header {\n  text-align: center;\n}\n\n.leaderboard-table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #f8f9fa;\n  vertical-align: middle;\n  font-size: 0.9rem;\n}\n\n.leaderboard-row {\n  transition: background-color 0.2s ease;\n}\n\n.leaderboard-row:hover {\n  background-color: #f8f9fa;\n}\n\n.leaderboard-row:last-child td {\n  border-bottom: none;\n}\n\n/* Призовые места */\n.prize-1 {\n  background-color: rgba(255, 215, 0, 0.1);\n}\n\n.prize-2 {\n  background-color: rgba(192, 192, 192, 0.1);\n}\n\n.prize-3 {\n  background-color: rgba(205, 127, 50, 0.1);\n}\n\n.prize-4, .prize-5 {\n  background-color: rgba(74, 144, 226, 0.1);\n}\n\n.position-cell {\n  font-weight: 600;\n  color: #495057;\n  text-align: center;\n  width: 80px;\n}\n\n.address-cell {\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  color: #495057;\n  font-size: 0.85rem;\n}\n\n.address-link {\n  color: #007bff;\n  text-decoration: none;\n  transition: color 0.2s ease;\n  border-radius: 4px;\n  padding: 2px 4px;\n  display: inline-block;\n}\n\n.address-link:hover {\n  color: #0056b3;\n  background-color: rgba(0, 123, 255, 0.1);\n  text-decoration: underline;\n}\n\n.balance-cell {\n  font-weight: 600;\n  color: #5d8a66;\n  text-align: right;\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n}\n\n.change-cell {\n  font-weight: 600;\n  text-align: center;\n  font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;\n  font-size: 0.9rem;\n  width: 120px;\n}\n\n.change-positive {\n  color: #28a745;\n  font-weight: 500;\n}\n\n.change-negative {\n  color: #dc3545;\n  font-weight: 500;\n}\n\n.change-neutral {\n  color: #6c757d;\n  font-weight: 500;\n}\n\n.no-data {\n  text-align: center;\n  padding: 40px 20px;\n  color: #6c757d;\n}\n\n.no-data-icon {\n  font-size: 3rem;\n  margin-bottom: 15px;\n}\n\n.no-data h3 {\n  margin-bottom: 8px;\n  color: #495057;\n  font-weight: 500;\n}\n\n/* Responsive design */\n@media (max-width: 768px) {\n  .leaderboard-table th,\n  .leaderboard-table td {\n    padding: 10px 10px;\n    font-size: 0.85rem;\n  }\n  \n  .position-cell {\n    width: 60px;\n  }\n}\n\n@media (max-width: 480px) {\n  .leaderboard-table th,\n  .leaderboard-table td {\n    padding: 8px 10px;\n    font-size: 0.8rem;\n  }\n  \n  .position-cell {\n    width: 50px;\n  }\n  \n  .address-cell {\n    font-size: 0.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
